import { render, staticRenderFns } from "./ConfirmRegister.vue?vue&type=template&id=1ec17548"
import script from "./ConfirmRegister.vue?vue&type=script&lang=js"
export * from "./ConfirmRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports